import { types } from '../actions/areaActions';
import initialState from './initialState';

export default function areaReducer(state = initialState.areaReducer, action) {
  switch (action.type) {
    case types.LOAD_AREA_SUCCESS:
      return { ...state, areas: action.areas, loading: false };
    case types.CREATE_AREA_SUCCESS: {
      const area = action.area.map((val) => val);
      return {
        ...state,
        areas: [...(state.areas || []), ...area],
      };
    }
    case types.UPDATE_AREA_SUCCESS: {
      const updatedArea = action.area.map((val) => val);
      return {
        ...state,
        areas: [...(state.areas || []).filter((area) => area.areaId !== action.areaId), ...updatedArea],
      };
    }
    case types.DELETE_AREA_SUCCESS:
      return { ...state, areas: (state.areas || []).filter((team) => team.areaId !== action.id) };
    case types.LOAD_ALL_STOPS_SUCCESS:
      return { ...state, allStops: action.stops };
    case types.LOAD_STOP_SUCCESS:
      return { ...state, stops: action.stops };
    case types.LOAD_AREA_USER_SUCCESS:
      return { ...state, users: action.users };
    case types.LOAD_SINGLE_AREA_SUCCESS:
      return { ...state, area: action.area };
    case types.AREA_LOADING_START:
      return { ...state, areas: [], loading: true };
    case types.LOAD_RAW_AREA_SUCCESS:
      return { ...state, rawAreas: action.areas };
    default:
      return state;
  }
}
